import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';
import axios from 'axios';
import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';
import {
    dataTableLanguaje, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import {
    userEmailVerificationSendPostAsync, userAccountEnnableDisablePostAsync, userProcessButtonsGet, userEmailWellcomePostAsync, userAccountApprovedPostAsync, userAccountDeletePostAsync,
    userRegisterResetPostAsync
} from '../../controllers/users/users';
import Menu from '../main/Menu';
import UsersAddEdit from './UsersAddEdit';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { userModelGet } from '../../models/users/user';

const currentMethod = 'Users';

const { app, html, icons, images, labels, messages, react } = globalSettings;
const { backend, } = app;
const { html: reactHtml, } = react;

export default function Users({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let headerObj = {};
    const dtUsersId = 'dtUsers';
    const auth = useAuth();
    //const history = useHistory();
    //const userRole = checkIfUserIsMaster({email: auth?.user?.email || '', languageId: '', subMethod: '', })?.result;
    const [showModal, setShowModal] = useState(false);
    const [dtRowIndexTwo, setDtRowIndexTwo] = useState(0);
    const [processType, setProcessType] = useState();
    const [user, setUser] = useState({});
    const [roles, setRoles] = useState([]);
    //const [showData, setShowData] = useState(false);
    const [showLoading, setShowLoading] = useState({ users: true });
    //#endregion variables

    //#region methods (Users)
    const userEditGetAsync = async ({
        id = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'userEditGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ users: true, });

            //#region user get
            response = await userByIdGetAsync({
                id: id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ users: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setUser(response?.result || {});
            //#endregion user get

            //#region roles get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlRoles}/`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result.data;
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ users: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setRoles(response?.result || []);
            //#endregion roles get

            setProcessType(1);
            setDtRowIndexTwo(rowIndex);

            setShowModal(true);

            setShowLoading({ users: false, });
        } catch (ex) {
            setShowLoading({ users: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const userRegisterResetAsync = async ({
        id = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'userRegisterResetAsync';
        let response = responseGet();
        try {
            setShowLoading({ users: true, });

            //#region variables
            let userLocal = userModelGet({});
            //#endregion variables

            //#region user get
            response = await userByIdGetAsync({
                id: id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ users: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            userLocal = response?.result || {};

            setShowLoading({ users: false, });
            //#endregion user get

            //#region userRegisterReset
            response = await userRegisterResetPostAsync({
                user: userLocal,
                dtUsers: $(`#${dtUsersId}`)?.DataTable(),
                rowIndex: rowIndex,
                auth: auth,
                languageObj: languageObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion userRegisterReset
        } catch (ex) {
            setShowLoading({ users: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const localSetEmailVerificationAsync = async (id = '', rowIndex = 0) => {
    //     let response = responseGet();
    //     try {
    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         response = await userByIdGetAsync(id);
    //         if (!response?.isSuccess || response?.isWarning) {
    //             await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth);
    //             return;
    //         }

    //         response = await setEmailVerificationGetShowModalAsync(response.result, $(`#${dtUsersId}`)?.DataTable(), rowIndex, auth);
    //         if (!response?.isSuccess || response?.isWarning) {
    //             await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth);
    //             return;
    //         }

    //         sendMessage(response.msgType, messages?.processesCompletedSuccessfully?.[languageObj?.id], null, true, false, null, '');
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: localSetEmailVerificationAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code

    const userEmailVerificationSendAsync = async ({
        id = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            setShowLoading({ users: true, });

            //#region variables
            let userLocal = userModelGet({});
            //#endregion variables

            //#region user get
            response = await userByIdGetAsync({
                id: id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ users: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            userLocal = response?.result || {};

            setShowLoading({ users: false, });
            //#endregion user get

            //#region userEmailVerificationSendPostAsync
            response = await userEmailVerificationSendPostAsync({
                user: userLocal,
                dtUsers: $(`#${dtUsersId}`)?.DataTable(),
                rowIndex: rowIndex,
                auth: auth,
                languageObj: languageObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion userEmailVerificationSendPostAsync
        } catch (ex) {
            setShowLoading({ users: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const userAccountApprovedAsync = async ({
        id = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'userAccountApprovedAsync';
        let response = responseGet();
        try {
            setShowLoading({ users: true, });

            //#region variables
            let userLocal = userModelGet({});
            //#endregion variables

            //#region user get
            response = await userByIdGetAsync({
                id: id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ users: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            userLocal = response?.result || {};

            setShowLoading({ users: false, });
            //#endregion user get

            //#region userAccountApprovedPostAsync
            response = await userAccountApprovedPostAsync({
                user: userLocal,
                dtUsers: $(`#${dtUsersId}`)?.DataTable(),
                rowIndex: rowIndex,
                auth: auth,
                languageObj: languageObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion userAccountApprovedPostAsync
        } catch (ex) {
            setShowLoading({ users: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const userEmailWellcomeSendAsync = async ({
        id = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'userEmailWellcomeSendAsync';
        let response = responseGet();
        try {
            setShowLoading({ users: true, });

            //#region variables
            let userLocal = userModelGet({});
            //#endregion variables

            //#region user get
            response = await userByIdGetAsync({
                id: id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ users: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            userLocal = response?.result || {};

            setShowLoading({ users: false, });
            //#endregion user get

            //#region userEmailWellcomePostAsync
            response = await userEmailWellcomePostAsync({
                user: userLocal,
                dtUsers: $(`#${dtUsersId}`)?.DataTable(),
                rowIndex: rowIndex,
                auth: auth,
                languageObj: languageObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion userEmailWellcomePostAsync
        } catch (ex) {
            setShowLoading({ users: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const userAccountEnnableDisableGetAsync = async ({
        id = '',
        rowIndex = 0,
        subMethod = ''
    }) => {
        const currentMethod = 'userAccountEnnableDisableGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ users: true, });

            //#region variables
            let userLocal = userModelGet({});
            //#endregion variables

            //#region user get
            response = await userByIdGetAsync({
                id: id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ users: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            userLocal = response?.result || {};

            setShowLoading({ users: false, });
            //#endregion user get

            //#region userAccountEnnableDisablePostAsync
            response = await userAccountEnnableDisablePostAsync({
                user: userLocal,
                dtUsers: $(`#${dtUsersId}`)?.DataTable(),
                rowIndex: rowIndex,
                auth: auth,
                languageObj: languageObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion userAccountEnnableDisablePostAsync
        } catch (ex) {
            setShowLoading({ users: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const userAccountDeleteGetAsync = async ({
        id = '',
        rowIndex = '',
        subMethod = ''
    }) => {
        const currentMethod = 'userAccountDeleteGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ users: true, });

            //#region variables
            let userLocal = userModelGet({});
            //#endregion variables

            //#region user get
            response = await userByIdGetAsync({
                id: id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ users: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            userLocal = response?.result || {};

            setShowLoading({ users: false, });
            //#endregion user get

            //#region userAccountDeletePostAsync
            response = await userAccountDeletePostAsync({
                user: userLocal,
                dtUsers: $(`#${dtUsersId}`)?.DataTable(),
                rowIndex: rowIndex,
                auth: auth,
                languageObj: languageObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }
            //#endregion userAccountDeletePostAsync
        } catch (ex) {
            setShowLoading({ users: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const userByIdGetAsync = async ({
        id = '',
        subMethod = '',
    }) => {
        const currentMethod = 'userByIdGetAsync';
        let response = responseGet();
        try {
            //#region methods
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion methods (users)

    //#region methods (others
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let userLocal = [userModelGet({})];
            //#endregion variables

            //#region dataTable set
            response = dataTablesSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTable set

            //#region queryCode set
            response = queryCodeSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion queryCode set

            setShowLoading({ users: true, });

            //#region data get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ users: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            userLocal = response?.result || [];

            //#region dataTable user set
            userLocal?.forEach(async (detail) => {
                response = userProcessButtonsGet({
                    user: detail,
                    languageObj: languageObj,
                    subMethod: currentMethod,
                });

                if (!response.isSuccess || response.isWarning) {
                    setShowLoading({ users: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                dtRows.push(response.result);
            });
            //#endregion dataTable user set
            //#endregion data get

            //#region load datatable
            $(`#${dtUsersId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion load datatable

            setShowLoading({ users: false, });
        } catch (ex) {
            setShowLoading({ users: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            $(`#${dtUsersId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.email?.[languageObj?.id], width: '25%', orderable: true, },
                    {
                        title: labels?.registry?.[languageObj?.id],
                        orderable: true,
                        render: function (data, type, row) {
                            return `<span style='font-size:14px;'>${data}</span>`;
                        },
                        width: '15%',
                    },
                    //{ className: '', title: `${labels?.delete?.[languageObj?.id]}?`, width: '10%', orderable: true, },
                    { className: '', title: `${labels?.deleted?.[languageObj?.id]}?`, width: '10%', orderable: true, },
                    { className: '', title: `${labels?.disabled?.[languageObj?.id]}?`, width: '10%', orderable: true, },
                    { className: '', title: `${labels?.confirmedEmail?.[languageObj?.id]}?`, width: '15%', orderable: true, },
                    { className: '', title: `${labels?.authorized?.[languageObj?.id]}?`, width: '10%', orderable: true, },
                    //{ className: '', title: `${labels?.assignedRole?.[languageObj?.id]}?`, width: '10%', orderable: true, },
                    { className: '', title: `${labels?.role?.[languageObj?.id]}?`, width: '10%', orderable: true, },
                    { className: '', title: labels?.process?.[languageObj?.id], width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                order: [[0, 'asc']],
            });
            //.buttons().container().appendTo(`#${dtUsersId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            //#endregion variables

            //#region methods
            $(`#${dtUsersId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtUsersId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    switch (method) {
                        case 'edit':
                            userEditGetAsync({ id: id, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case backend?.methods?.restoreRegister:
                            userRegisterResetAsync({ id: id, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case backend?.methods?.emailConfirmSend:
                            userEmailVerificationSendAsync({ id: id, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case backend?.methods?.authUser:
                            userAccountApprovedAsync({ id: id, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case backend?.methods?.wellEmail:
                            userEmailWellcomeSendAsync({ id: id, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case backend?.methods?.enableDisableAccount:
                            userAccountEnnableDisableGetAsync({ id: id, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case backend?.methods?.deleteAccount:
                            userAccountDeleteGetAsync({ id: id, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad'
        });
    }, [auth]) // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='settings' process='users' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.users?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.users?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={reactHtml?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.users}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.users?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.usersLogo}></img> - {labels?.users?.[languageObj?.id]}
                                        </h6>
                                        {/* <div className='card-tools'> */}
                                        {/* <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right btn-sm' onClick={()=> localUserAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        {/* </div> */}
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>
                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                {/* <div> */}
                                                <div className={html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtUsersId} className={html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* </div> */}
                                                {/* : */}
                                                {/* <div></div> */}
                                                {/* } */}
                                            </div>
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={globalSettings?.colors?.infoColorExp}
                                                    msgText={messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>

                                    </div> {/*card body*/}

                                    <div className='card-footer'>

                                    </div> {/*card footer*/}

                                </div>{/*card*/}

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {showModal ?
                <UsersAddEdit $={$}
                    auth={auth}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    user={user}
                    setUser={setUser}
                    roles={roles}
                    dtId={dtUsersId}
                    dtRowIndex={dtRowIndexTwo}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}